import { combineReducers } from "redux";
import bbox from "./set_bbox";

const rootReducer = combineReducers({
  bbox,
});

export default rootReducer;
